import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./menuLink.scss";
import { AuthContext } from "../../context/AuthContext";

const MenuLink = ({ Icon, text }) => {
  const { setCurrentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const cerrarSesion = () => {
    console.log("Cerrando sesión, espere un momento...");
    localStorage.removeItem("token");
    localStorage.removeItem("rol");
    setCurrentUser(null);

    console.log("Redirigiendo a /Login...");
    navigate("/Login");
  };

  const isLogoutText = (t) => t === "Logout" || t === "Cerrar sesión" || t === "Cerrar Sesión";

  const handleClick = () => {
    if (isLogoutText(text)) {
      cerrarSesion();
    }
  };

  return (
    <div className="menuLink" onClick={handleClick} style={{ cursor: "pointer" }}>
      {Icon}
      <span className="menuLinkText">{text}</span>
    </div>
  );
};

export default MenuLink;
